<template>
  <ObjectListTabs>
    <template slot-scope="{}">
      <b-nav-item :to="{name: 'fan-profile-preview'}">Public profile</b-nav-item>
      <b-nav-item :to="{name: 'fan-profile-edit'}">Personal information</b-nav-item>
      <b-nav-item :to="{name: 'fan-billing-info'}">Payments</b-nav-item>
      <b-nav-item :to="{name: 'fan-blocked-users'}">Blocked users</b-nav-item>
    </template>
  </ObjectListTabs>
</template>

<script>
import { mapGetters } from 'vuex'

import ObjectListTabs from '@/components/widgets/ObjectListTabs'

export default {
  name: 'FanProfileTabs',
  components: {
    ObjectListTabs
  },
  computed: {
    ...mapGetters('profile', ['currentUser'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FanEditProfileTabs.vue